'use client';
import { useRouter } from 'next/navigation';
import { usePathname } from 'next/navigation';

import { sortControls } from '../utils';
import { cn } from '@/lib/utils';

const ServiceMenu = () => {
  const router = useRouter();
  const pathname = usePathname();
  const activeCategory = pathname.split('/').slice(-1)[0];

  // route to correct [slug] page
  // TODO: Add 404 page when not legit category is hit
  const handleCategory = (category?: string) => {
    if (category) {
      router.push(`/services/${category}`);
    } else {
      router.push('/services');
    }
  };

  return (
    <nav className="mb-[70px] mt-10 md:mb-5">
      <ul className="flex flex-col items-center justify-center border-b-rm-gray-100 md:flex-row md:gap-[45px] md:border-b">
        {sortControls.map((control) => (
          <li
            key={control.id}
            data-name-control-catory={control.category}
            className={cn(
              'w-full border-b border-b-rm-gray-100 py-4 text-center text-rm-gray-100 md:w-auto md:border-none md:pb-5',
              activeCategory === control.category &&
                'border-b border-b-rm-neutral-700 text-rm-neutral-700 md:border-none',

              activeCategory == 'services' &&
                !control.category &&
                'border-b border-b-rm-neutral-700 text-rm-neutral-700 md:border-none'
            )}
          >
            <button
              className={cn(
                'lg:hover:text-rm-gray-400 text-nowrap text-[22px] font-semibold md:text-xl lg:text-2xl lg:hover:text-rm-neutral-500',
                activeCategory === control.category &&
                  'lg:hover:text-rm-neutral-700',
                activeCategory == 'services' &&
                  !control.category &&
                  'lg:hover:text-rm-neutral-700'
              )}
              onClick={() => handleCategory(control.category)}
            >
              {control.label}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default ServiceMenu;
